/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Beschreibung',
    END_DATE: 'Bis',
    ID: 'ID',
    OBJECTIVE: 'Ziel',
    REWARD: 'Prämie',
    START_DATE: 'Am'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Gesammelter Wert',
    ACTIVES: 'Aktive',
    AT: 'Am',
    COUPON: 'Gutschein',
    CREATED: 'Erstellt',
    DAY_VALUE: 'Tageswert',
    FAIL: 'Gescheitert',
    FINISHED: 'Abgeschlossen',
    HISTORY: 'Verlauf',
    IN_PROGRESS: 'Im Gange',
    MONETARY_REWARD: 'Prämie',
    NR_ACCESSES: 'Neue Besuche',
    NR_NEW_CLIENTS: 'Neue Kunden',
    NR_ORDERS: 'Bestellungen',
    OBJECTIVE: 'Ziel',
    OBJECTIVE_VALUE: 'Zielwert',
    OFFER: 'Belohnung',
    OPEN: 'Öffnen',
    REMUNERATION: 'Vergütung',
    REWARD_TYPE: 'Prämienart',
    REWARD_TYPES: 'Prämienarten',
    SALES: 'Verkäufe',
    SALES_BRANDS: 'Zu verkaufende Linien (€)',
    SALES_BRANDS_QTY: 'Zu verkaufende Linien (Menge)',
    SALES_CATEGORY: 'Zu verkaufende Kategorie (€)',
    SALES_CATEGORY_QTY: 'Zu verkaufende Kategorie (Menge)',
    SALES_COMMISSIONS: 'Verkaufsprovisionen',
    SALES_PRODUCTS: 'Zu verkaufende Produkte (€)',
    SALES_PRODUCTS_QTY: 'Zu verkaufende Produkte (Menge)',
    SUCCESS: 'Erfolgreich',
    TO: '{0} bis {1}',
    TODAY: 'Heute'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Es sind (noch) keine Challenges aktiv.',
    CHALLANGES_TITLE: 'Keine Challenges.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
